import { useEffect } from "react";

const getOriginUrls = () => {
  const hostname = window.location.hostname;
  let authBaseURL = "https://accounts.vecros.com";
  const appOrigin = window.location.origin;
  let redirectUrl = encodeURIComponent(appOrigin);

  if (hostname === "localhost") {
    authBaseURL = "http://localhost:3000";
    redirectUrl = encodeURIComponent(appOrigin);
    return {
      AUTH_URL: `${authBaseURL}/session-sync?origin=${redirectUrl}`,
      ORIGIN_URL: `${authBaseURL}`,
    };
  }

  return {
    AUTH_URL: `${authBaseURL}/session-sync?origin=${redirectUrl}`,
    ORIGIN_URL: `${authBaseURL}`,
  };
};

export const SessionSyncFrame = ({ onSessionReceived, onSessionFailed }) => {
  const { AUTH_URL, ORIGIN_URL } = getOriginUrls();

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== ORIGIN_URL) return;
      if (!event.data || event.data.source !== "session-sync") return;
      const { token, email, exp } = event.data;
      if (token && exp) {
        onSessionReceived({ token, email, exp });
      } else {
        onSessionFailed?.();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onSessionReceived, onSessionFailed, ORIGIN_URL]);

  return (
    <iframe
      src={AUTH_URL}
      style={{ display: "none" }}
      title="session-sync"
      id="session-sync-iframe"
    />
  );
};
